import { render, staticRenderFns } from "./ArmazemTabList.vue?vue&type=template&id=3e812df5&scoped=true"
import script from "./ArmazemTabList.vue?vue&type=script&lang=js"
export * from "./ArmazemTabList.vue?vue&type=script&lang=js"
import style0 from "./ArmazemTabList.vue?vue&type=style&index=0&id=3e812df5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e812df5",
  null
  
)

export default component.exports